/**
 * The "new studio" dialog's simulator defaults (the template's host and port
 * block): `?simHost=&simBasePort=` on the studios page when given — what
 * `pnpm dev:studio` prints as the link to open, since a worktree's simulators
 * are not on the primary checkout's block — else loopback and the primary
 * checkout's block (dev/sessionPorts.ts, slot 0). Pure: the view passes
 * `window.location.search`.
 */
export type SimDefaults = { readonly host: string; readonly basePort: number };

export const FALLBACK_SIM_DEFAULTS: SimDefaults = { host: '127.0.0.1', basePort: 23000 };

/** A hostname or an IP literal: no scheme, path or spaces (it goes into the config as is). */
const HOST = /^[A-Za-z0-9.:[\]-]{1,253}$/;

export function simDefaultsFrom(search: string): SimDefaults {
  const params = new URLSearchParams(search);
  const host = params.get('simHost');
  const port = Number(params.get('simBasePort') ?? Number.NaN);
  return {
    host: host !== null && HOST.test(host) ? host : FALLBACK_SIM_DEFAULTS.host,
    // The devices listen on base + 5..7: the block must leave room for them (the dialog's own bound).
    basePort: Number.isInteger(port) && port > 0 && port < 65_530 ? port : FALLBACK_SIM_DEFAULTS.basePort,
  };
}
